<template>
  <div class="container">
    <div class="navi">
        <a @click="goto('/general-step4')">
          <span class="icon-arrow-left"></span>
        </a>
    </div>
    <div class="title">服务咨询（可选）</div>

    <div class="weui-msg" v-show="true">
        <div class="weui-msg__icon-area"><img class="phonechat" src="../../assets/img/global/empty.svg"></div>
        <div class="weui-msg__text-area">
            <p class="clean-text">感谢您填写了订单详情，在您支付定金之前，如有任何疑惑或服务要求，可通过下面方式联系我们详谈<br></p>
        </div>
        <div class="weui-msg__opr-area btn-padding">
            <p class="weui-btn-area">
                <div class="weui-btn weui-btn_primary" @click="doCopy()"><span class="icon-wechat"></span> 微信在线客服</div>
                <a href="tel:0477747777" class="weui-btn weui-btn_default"><span class="icon-phone"></span> 电话联系我们</a>
            </p>
        </div>
    </div>

    <div v-show="showWechat">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__hd"><strong class="weui-dialog__title">微信号已复制</strong></div>
            <div class="weui-dialog__bd">微信号 <span class="color-wechat wehchat-id">daojia005</span> 复制成功！请进入微信粘贴搜索该微信号，添加好友</div>
            <div class="weui-dialog__ft">
                <a href="javascript:void()" class="weui-dialog__btn weui-dialog__btn_default"  @click="showWechat=false">关闭</a>
                <a href="weixin://" class="weui-dialog__btn weui-dialog__btn_primary color-wechat" >打开微信</a>
            </div>
        </div>
    </div>

    <div class="btn-box-fix" >
      <div class="btn-container">
        <a href="javascript:void(0)" class="btn active" @click="goto('/general-step6') ">下一步</a>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'contact',
  data () {
    return {
      showWechat:false
    }
  },
  computed: {
    notWechat(){
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
          return false;
      } else {
          return true;
      }
    }
  },
  methods: {
    doCopy: function () {
      let that = this;
      this.$copyText("daojia005").then(function (e) {
        that.showWechat=true;
        console.log(e)
      }, function (e) {
        console.log(e)
      })
    }
  },
  created: function () {
      document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
      document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ .weui-msg{
  padding-top:0;
}

.weui-msg__opr-area{
  padding:0 2em;
}

.phonechat{
  width:60%;
}

.color-wechat{
  color:#0BB20C!important;
}

.wehchat-id{
  font-size:1.1em;
  padding:0 4px;
}

.qrzone{
  text-align:center;
  margin-top:30px;
  img{
    background:#fff;
    max-width:100%;
    padding:14px;
    border:1px solid #eee;
    width:70%;
  }
}

.weui-btn_daojia{
  background-color:$color-orange-dark;
}

.clean-text{
    font-size: 14px;
    color: #666;
}
</style>



// WEBPACK FOOTER //
// src/pages/general/step5.vue